import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {RequestAllAcrReportDto, ResponsePreviewDto} from "../dto/acr-report.dto";
import {ResponseData} from "../../nest-responses";

@Injectable()
export class AcrReportApi {
  private readonly service: string = '';
  private readonly model: string = 'att/shared/attcorrectionreport';

  constructor(
    private readonly nestApiProvider: NestApiProvider,
  ) {
  }

  public preview(payload: RequestAllAcrReportDto): Observable<ResponsePreviewDto> {
    const method: string = 'POST';
    const func: string = 'preview';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePreviewDto>(method, url, params, urlParams, body);
  }

  public downloadExcel(payload: RequestAllAcrReportDto): Observable<Blob> {
    const method: string = 'POST';
    const func: string = 'downloadExcel';
    const params: any = payload || {};
    const urlParams: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<Blob>(method, url, params);
  }

  public sendMailPdf(payload: RequestAllAcrReportDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'sendMailPdf';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public sendMailExcel(payload: RequestAllAcrReportDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'sendMailExcel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public downloadPdf(payload: RequestAllAcrReportDto): Observable<Blob> {
    const method: string = 'POST';
    const func: string = 'downloadPdf';
    const params: any = payload || {};
    const urlParams: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<Blob>(method, url, params);
  }

  public correctionStatus(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'correctionStatus';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body, null);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/acr-report.api.ts